import * as Yup from 'yup'
import { PASSWORD_REGEX, PHONE_REGEX } from '../../constants';


export const signUpValidation = Yup.object().shape({
  firstName:
    Yup.string()
    .required("First name is required"),
  lastName:
    Yup.string()
    .required("Last name is required"),
  email:
    Yup.string()
    .email('Please enter a valid email.')
    .required('Email is required.'),
  phone:
    Yup
    .string()
    .matches(PHONE_REGEX, 'Phone number is not valid')
    .required('Ya phone is required.')
})

export const createCompanyValidation = Yup.object().shape({
  name:
    Yup.string()
    .required('Name is required'),
  size:
    Yup.string()
    .required('Size is required'),
  type:
    Yup.string()
    .required('Type is required')
})

export const passwordValidation = Yup.object().shape({
  password:
    Yup.string()
    .matches(PASSWORD_REGEX)
    .required("Password is required"),
  confirmPassword:
    Yup.string()
    .matches(PASSWORD_REGEX)
    .required("Password is required"),
    //TODO: Confirm how to make sure both passwords are the same
})
